import { Component } from "@angular/core";

import * as BUILD from "../../../../../../src/build";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"]
})
export class FooterComponent {
  readonly buildNumber = BUILD.default.label;
  readonly envLabel = this._getEnvLabel();

  private _getEnvLabel(): string | null {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return "DEV";
    if (host.startsWith("staging.")) return "STAGING";
    return null;
  }
}
